
// XSS 过滤：移除 script 标签和事件属性，保留安全 HTML（img、br、b 等）
const sanitizeHtml = (html) => {
	if (!html) return ''
	return String(html)
		.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
		.replace(/\son\w+\s*=\s*(['"])[^'"]*\1/gi, '')
		.replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
		.replace(/javascript\s*:/gi, '')
}

//时间戳转时间
const timestampToTime = (timestamp) => {
	if(!timestamp) return ""
	var date = new Date(timestamp + 8 * 3600 * 1000); // 增加8小时
	return date.toJSON().substr(0, 19).replace('T', ' ');
}

// 2026-01-26T15:34:54  转时间
const timesToTime = (timestamp) => {
	 if (!timestamp) return ''
	  const finalStr = timestamp + 'Z'
	  const date = new Date(finalStr)
	  return date.toLocaleString('sv-SE') // 瑞典格式 = YYYY-MM-DD HH:mm:ss
}



export default {
	timestampToTime,
	timesToTime,
	sanitizeHtml
}